<section class="app-navigation">
  <div class="app-navigation-container">
    <div class="d-flex flex-column breadcrumbs">
      <ng-content></ng-content>
    </div>
    <div class="d-flex flex-column search-container">
      <app-search></app-search>
    </div>
  </div>
</section>
